'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * This "component" is only used to call its
 * `.listenToTouches()` and `.stopListeningToTouches()`
 * methods manually through a `ref`.
 */
var OnTapOutside = (_temp2 = _class = function (_React$Component) {
	_inherits(OnTapOutside, _React$Component);

	function OnTapOutside() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, OnTapOutside);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OnTapOutside.__proto__ || Object.getPrototypeOf(OnTapOutside)).call.apply(_ref, [this].concat(args))), _this), _this.onTouchStart = function (event) {
			// Ignore multitouch.
			if (event.touches.length > 1) {
				// Reset.
				return _this.onTouchCancel();
			}
			var touch = event.changedTouches[0];
			_this.initialTouchX = touch.clientX;
			_this.initialTouchY = touch.clientY;
			_this.touchId = touch.identifier;
			_this.tapping = true;
		}, _this.onTouchMove = function (event) {
			var moveThreshold = _this.props.moveThreshold;


			if (!_this.tapping) {
				return;
			}

			var x = void 0;
			var y = void 0;
			for (var _iterator = event.changedTouches, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
				var _ref2;

				if (_isArray) {
					if (_i >= _iterator.length) break;
					_ref2 = _iterator[_i++];
				} else {
					_i = _iterator.next();
					if (_i.done) break;
					_ref2 = _i.value;
				}

				var touch = _ref2;

				if (touch.identifier === _this.touchId) {
					x = touch.clientX;
					y = touch.clientY;
					break;
				}
			}

			// If not the touch.
			if (x === undefined) {
				return;
			}

			var deltaX = Math.abs(x - _this.initialTouchX);
			var deltaY = Math.abs(y - _this.initialTouchY);

			// Reset on touch move.
			if (deltaX > moveThreshold || deltaY > moveThreshold) {
				_this.onTouchCancel();
			}
		}, _this.onTouchEnd = function (event) {
			if (!_this.tapping) {
				return;
			}

			for (var _iterator2 = event.changedTouches, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
				var _ref3;

				if (_isArray2) {
					if (_i2 >= _iterator2.length) break;
					_ref3 = _iterator2[_i2++];
				} else {
					_i2 = _iterator2.next();
					if (_i2.done) break;
					_ref3 = _i2.value;
				}

				var touch = _ref3;

				if (touch.identifier === _this.touchId) {
					// Reset.
					_this.onTouchCancel();
					// Handle the tap.
					// https://developer.mozilla.org/en-US/docs/Web/API/Touch
					_this.onTap(event, touch.target);
					break;
				}
			}
		}, _this.onTouchCancel = function () {
			_this.initialTouchX = undefined;
			_this.initialTouchY = undefined;
			_this.touchId = undefined;
			_this.tapping = false;
		}, _this.onTap = function (event, target) {
			var _this$props = _this.props,
			    getContainerNode = _this$props.getContainerNode,
			    getTogglerNode = _this$props.getTogglerNode,
			    onTapOutside = _this$props.onTapOutside;


			if (getContainerNode().contains(target)) {
				return;
			}

			if (getTogglerNode) {
				if (getTogglerNode().contains(target)) {
					return;
				}
			}

			if (onTapOutside) {
				_this.focusOut = true;
				onTapOutside(event);
				_this.focusOut = undefined;
			}
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(OnTapOutside, [{
		key: 'listenToTouches',
		value: function listenToTouches() {
			document.addEventListener('touchstart', this.onTouchStart);
			document.addEventListener('touchmove', this.onTouchMove);
			document.addEventListener('touchend', this.onTouchEnd);
			document.addEventListener('touchcancel', this.onTouchCancel);
		}
	}, {
		key: 'stopListeningToTouches',
		value: function stopListeningToTouches() {
			document.removeEventListener('touchstart', this.onTouchStart);
			document.removeEventListener('touchmove', this.onTouchMove);
			document.removeEventListener('touchend', this.onTouchEnd);
			document.removeEventListener('touchcancel', this.onTouchCancel);
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.stopListeningToTouches();
		}

		// On mobile devices "blur" event isn't triggered
		// when a user taps outside. This is to allow touch scrolling
		// while not losing focus on an input field or a button.
		// Adding a manual "on click" listener to emulate
		// "on blur" event when user taps outside (to collapse the expandable).

	}, {
		key: 'render',
		value: function render() {
			var children = this.props.children;

			return children;
		}
	}]);

	return OnTapOutside;
}(_react2.default.Component), _class.propTypes = {
	onTapOutside: _propTypes2.default.func.isRequired,
	getTogglerNode: _propTypes2.default.func,
	getContainerNode: _propTypes2.default.func.isRequired,
	moveThreshold: _propTypes2.default.number.isRequired
}, _class.defaultProps = {
	moveThreshold: 5
}, _temp2);
exports.default = OnTapOutside;
//# sourceMappingURL=OnTapOutside.js.map